/* El <dialog> nativo es sólo el marco: sin padding ni fondo, para que un click
   que le llega a él sea un click en el scrim. El panel visible es `.panel`. */
.dialog {
  --_w: var(--w-dialog-md);

  width: min(var(--_w), calc(100vw - 2 * var(--gutter-page)));
  max-height: calc(100dvh - 2 * var(--gutter-page));
  margin: auto;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--text-body);
  overscroll-behavior: contain;
}
.dialog[data-size="sm"] {
  --_w: var(--w-dialog-sm);
}
.dialog[data-size="lg"] {
  --_w: var(--w-dialog-lg);
}
.dialog::backdrop {
  background: var(--scrim-dialog);
  -webkit-backdrop-filter: var(--blur-dialog);
  backdrop-filter: var(--blur-dialog);
}
.dialog:focus-visible {
  outline: none;
  box-shadow: none;
}

.panel {
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - 2 * var(--gutter-page));
  background: var(--surface-card);
  border-radius: var(--r-panel);
  box-shadow: var(--sh-xl);
  overflow: hidden;
}
.cabecera {
  display: flex;
  align-items: flex-start;
  gap: var(--s-6);
  padding: var(--s-8) var(--s-8) 0;
}
.textos {
  flex: 1;
  min-width: 0;
}
/* Título con, opcionalmente, un avatar a la izquierda y el subtítulo debajo. */
.encabezado {
  display: flex;
  align-items: center;
  gap: var(--s-5);
  min-width: 0;
}
.titulos {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  min-width: 0;
}
.subtitulo {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.titulo {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--fs-xl);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-subheading);
  line-height: var(--lh-snug);
  color: var(--text-strong);
}
.descripcion {
  margin: var(--s-4) 0 0;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  line-height: var(--lh-relaxed);
  color: var(--text-body);
}
.cuerpo {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: var(--s-6) var(--s-8) var(--s-8);
}
/* El pie no lleva banda propia: los botones a la derecha, sobre el mismo blanco. */
.pie {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--s-4);
  padding: 0 var(--s-8) var(--s-8);
}
/* Cabecera sin cuerpo ni pie: que no quede pegada al borde. */
.cabecera:last-child,
.cabecera:has(+ .pie) {
  padding-bottom: var(--s-8);
}
.cuerpo + .pie {
  padding-top: var(--s-2);
}

@media (max-width: 767px) {
  .dialog {
    width: calc(100vw - 2 * var(--s-5));
    max-height: calc(100dvh - 2 * var(--s-5));
  }
  .panel {
    max-height: calc(100dvh - 2 * var(--s-5));
  }
  .pie > * {
    flex: 1 1 auto;
  }
}
